module.exports = __webpack_public_path__ + "img/zxdt.5507bde2.png";